import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LoadingOverlayComponent } from "./components/loading-overlay/loading-overlay.component";

@Component({
	selector: "app-root",
	imports: [RouterOutlet, LoadingOverlayComponent],
	templateUrl: "./app.component.html",
	styleUrl: "./app.component.scss",
})
export class AppComponent {
	title = "matchie-admin-frontend";
}
